import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';

import * as cmAPI_Action from 'actions/commons';

import { Dropdown, Form, Input, Label, Icon, Button } from 'semantic-ui-react';

class SingleDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment()
    };
  }

  componentWillMount() {
    const { date } = this.state;
    this.handleChange(date);
  }

  handleChange = (date) => {
    const { type } = this.props;

    this.setState({ date: date });

    const { commonFn } = this.props;

    commonFn.changeDate({
      type: 'date',
      name: type,
      value: date.format('LLL')
    });
  };

  render() {
    const { type, disabled } = this.props;

    return (
      <span className="date-form">
        <Input labelPosition="right" type="text">
          <Label basic>
            <Icon disabled name="calendar" />
          </Label>
          <DatePicker
            disabled={disabled}
            selected={this.state.date}
            onChange={(e) => this.handleChange(e)}
            dateFormat="YYYY-MM-DD"
            placeholderText="YYYY-MM-DD"
          />
        </Input>
      </span>
    );
  }
}

SingleDatePicker = connect(
  (state) => ({
    date: state.commons.date
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeDate: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(SingleDatePicker);

export default SingleDatePicker;
